import * as types from '../actions/actionTypes';
import { TableViews } from '../../lib/constants';

const initialState = {
    filters: {
        view: TableViews.Standard,
        status: '',
        days: {
            Recent: 30,
            Paid: 30,
            Rejected: 30
        },
        inquireOnly: false,
        keyword: '',
        recipients: [],
        firstName: '',
        lastName: '',
        reportName: '',
        reportMemo: '',
        teudatZahut: '',
        phoneNumber: '',
        checkNumber: '',
        categories: [],
        nationalities: [],
        recipientTypes: [],
        recipientStatuses: [],
        applicationStatuses: [],
        applicationReasons: [],
        approvers: [],
        funds: [],
        references: [],
        sources: [],
        campaigns: [],
        campaignIndividualCategories: [],
        campaignLists: [],
        organizations: [],
        taxId: '',
        streetNames: [],
        cities: [],
        startDate: '',
        endDate: '',
        elasticSearchText: '',
        bankAccount: '',
        hasPledges: false,
        hasAchAccount: false,
        hasReceipt: null,
    },
    statusCounts: {
        loading: false,
        success: true,
        data: {
            new: '',
            inReview: '',
            incomplete: '',
            approved: '',
            paid: '',
            rejected: ''
        },
        currentRequestId: 0
    },
    selectedCounts: {
        ach: '',
        check:'',
        wire:''
    },
    applicationsToRecipientIdsMapping: {
        loading: false,
        success: true,
        data: {
            mapping: {},
            orderedApplications: []
        }
    },
    voidingPayment: {
        loading: false,
        success: true
    },
    sendingACH: {
        loading: false,
        success: true
    },
    updating: {
        loading: false,
        success: true
    }
}

export default (state = initialState, action) => {
    switch (action.type) {
        case types.UPDATE_APPLICATIONS_FILTERS:
            return Object.assign({}, state, { filters: { ...state.filters, ...action.update } });
        case types.RESET_APPLICATIONS_FILTERS:
            return Object.assign({}, state, { filters: initialState.filters });

        case types.START_GET_APPLICATION_STATUS_COUNTS:
            return Object.assign({}, state, { statusCounts: { ...state.statusCounts, loading: true, currentRequestId: action.requestId } });
        case types.GET_APPLICATION_STATUS_COUNTS:
            return action.requestId !== state.statusCounts.currentRequestId ? state
                : Object.assign({}, state, { statusCounts: { ...state.statusCounts, ...action.response } });

        case types.START_GET_APPLICATIONS_TABLE_RECORDS:
            return Object.assign({}, state, { applicationsToRecipientIdsMapping: initialState.applicationsToRecipientIdsMapping });
        case types.START_GET_APPLICATIONS_TO_RECIPIENT_IDS_MAPPING:
            return Object.assign({}, state, { applicationsToRecipientIdsMapping: { ...state.applicationsToRecipientIdsMapping, loading: true } });
        case types.GET_APPLICATIONS_TO_RECIPIENT_IDS_MAPPING:
            return Object.assign({}, state, { applicationsToRecipientIdsMapping: { ...state.applicationsToRecipientIdsMapping, ...action.response } });

        case types.START_UPDATE_APPLICATIONS_STATUS:
            return Object.assign({}, state, { updating: { ...state.updating, loading: true } });
        case types.UPDATE_APPLICATIONS_STATUS_COMPLETED:
            return Object.assign({}, state, { updating: { ...state.updating, ...action.response } });

        case types.START_VOID_APPLICATION_PAYMENT:
            return Object.assign({}, state, { voidingPayment: { ...state.voidingPayment, loading: true } });
        case types.VOID_APPLICATION_PAYMENT_COMPLETED:
            return Object.assign({}, state, { voidingPayment: { ...state.voidingPayment, ...action.response } });

        case types.START_SEND_ACH_APPLICATIONS:
            return Object.assign({}, state, { sendingACH: { ...state.sendingACH, loading: true } });
        case types.SEND_ACH_APPLICATIONS_COMPLETED:
            return Object.assign({}, state, { sendingACH: { ...state.sendingACH, ...action.response } });

        case types.UPDATE_SELECTED_COUNTS:
            return Object.assign({}, state, { selectedCounts: action.counts });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/ApplicationsReducer.js